import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/CreateEngagementInfluencerFolders.graphql';
import { Mutation, MutationcreateEngagementInfluencerFoldersArgs } from '../../__generated__/globalTypes';

export const useCreateEngagementInfluencerFoldersMutation = (
  options?: MutationHookOptions<Mutation, MutationcreateEngagementInfluencerFoldersArgs>
) => {
  const [callCreateEngagementInfluencerFolders, result] = useMutation<
    Mutation,
    MutationcreateEngagementInfluencerFoldersArgs
  >(MUTATION, options);

  return { callCreateEngagementInfluencerFolders, ...result };
};

export type CreateEngagementInfluencerFoldersMutationFunction = Mutation['createEngagementInfluencerFolders'];
